import React from 'react'

import { Trans } from 'react-i18next'

interface Props {
  monthlyPrice: string
  yearlyPrice: string
}

const PremiumPricing: React.FC<Props> = ({ monthlyPrice, yearlyPrice }) => (
  <p className="text-md">
    <Trans i18nKey="plans.premium.pricing">
      <span className="font-medium text-[22px]">${{ monthlyPrice }}</span>
      <span> / month or </span>
      <span className="font-medium text-[22px]">${{ yearlyPrice }}</span>
      <span> / year</span>
    </Trans>
  </p>
)

export default PremiumPricing
